import { Dialog, DialogContent } from '@mui/material';
import ViewReverse from './ViewReverse';
import Text from './Text';
import { fontSizes } from '../constants/constants';
import dynamicfunction from '../utils/dynamicfunction';
import Loader from './Loader';

const CustomModal = ({
  isOpen,
  onClose,
  isFullWidth,
  heading,
  loading = false,
  children,
  isCenter = true,
  color,
  size,
}) => {
  const { TextWeight } = dynamicfunction();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth={isFullWidth}
      PaperProps={{
        sx: {
          borderRadius: 3,
        },
      }}
    >
      <DialogContent>
        <ViewReverse className={'items-center justify-between'}>
          <Text
            text={heading}
            size={size ?? fontSizes.h18}
            className={'w-full'}
            isCenter={isCenter}
            weight={TextWeight.bold}
            color={color}
            isTruncate={false}
          />
        </ViewReverse>

        {loading ? (
          <Loader width={'w-8'} height={'h-8'} className={'my-3'} />
        ) : (
          children
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CustomModal;
